module.exports = __webpack_public_path__ + "static/media/general-data.2b365309.svg";